const styles = () => ({
  '.MuiOutlinedInput-root': {
    paddingTop: '9.5px',
    paddingBottom: '9.5px',
    paddingLeft: '14px !important',
    '.MuiAutocomplete-input': {
      padding: '0 !important',
      minWidth: '80px',
    },

    '.MuiSvgIcon-root': {
      fill: '#2845D2 !important',
      width: '18px',
      height: '18px',
    },

    '&.Mui-disabled': {
      '.MuiSvgIcon-root': {
        fill: 'rgba(0, 0, 0, 0.38) !important',
      },
    },
  },

  '.MuiChip-filled': {
    height: '23px',
    fontSize: '12px',
    background: 'rgba(29, 50, 153, 0.05)',
    border: '1px solid rgba(40, 69, 210, 0.3) !important',
    borderRadius: '5px !important',
    color: '#6A6A6A !important',
    '.MuiChip-label': {
      padding: '0 8px',
    },
  },

  '.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root': {
    paddingRight: '65px !important',
  },

  '&.dn-hide-label': {
    marginTop: '0',
    '.MuiInputLabel-root': {
      display: 'none',
    },
    '.MuiOutlinedInput-notchedOutline': {
      'legend > span': {
        display: 'none',
      },
    },
    '.MuiInputBase-sizeSmall': {
      height: '36px !important',
      paddingTop: '4.5px !important',
      paddingBottom: '4.5px !important',
    },
  },

  '&.dn-no-fix': {
    'input, .MuiChip-label': {
      textTransform: 'none !important',
    },
  },

  '&.dn-hide-popper': {
    '.MuiAutocomplete-popper': {
      display: 'none',
    },
  },

  '.MuiAutocomplete-popupIndicator': {
    transition: 'all 0.2s ease 0s',
  },
  '.dn-endAdornment': {
    position: 'absolute',
    right: '9px',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    '.MuiAutocomplete-endAdornment': {
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      position: 'initial',
      transform: 'translate(0, 0)',
      '.MuiAutocomplete-clearIndicator': {
        display: 'none !important',
      },
      '.MuiAutocomplete-clearIndicator, .MuiAutocomplete-popupIndicator': {
        padding: '2px',
      },
    },
  },
  '.MuiAutocomplete-root:hover .MuiAutocomplete-clearIndicator': {
    display: 'inline-flex !important',
  },
});

const filterStyles = () => ({
  marginTop: '0',
  '.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root': {
    paddingRight: '30px !important',
  },

  '.MuiOutlinedInput-root': {
    padding: '7.5px !important',

    '.MuiAutocomplete-input': {
      padding: '0 !important',
    },

    input: {
      fontSize: '11px !important',
      lineHeight: '15px !important',
      height: '15px !important',
    },
  },

  '.MuiOutlinedInput-notchedOutline': {
    'legend > span': {
      display: 'none !important',
    },
  },
});

export const checkBoxStyles = {
  marginRight: '8px',
  '& .MuiSvgIcon-root': {
    fontSize: '18px',
  },
};

export const autocompleteButtonStyles = () => ({
  borderTop: '1px solid #F8F8F8 !important',
  width: '100%',
  padding: '10px 15px !important',
  fontSize: '11px !important',
  lineHeight: '100% !important',
  color: 'rgba(75, 75, 75, 0.7);',
  textAlign: 'left !important',
  borderRadius: '0 !important',
});

export { styles, filterStyles };
